import React from 'react';
import { Heading2 } from '@awarego-ui/components';

const SmartVariablesPanel = ({ variables, onCopyVariable }) => {
    if (!variables || variables.length === 0) return null;

    return (
        <div className="smart-variables-panel">
            <Heading2 displayBlock my={8} style={{ fontSize: '18px' }}>
                Smart variables
            </Heading2>
            <div className="smart-variables-list">
                {variables.map((variable, index) => (
                    <div key={index} className="smart-variable-item">
                        <div className="smart-variable-name-wrapper">
                            <span
                                className="smart-variable-name"
                                data-plain-text={variable.name}
                                onClick={(e) => {
                                    const range = document.createRange();
                                    range.selectNodeContents(e.target);
                                    const selection = window.getSelection();
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }}
                            >
                                {variable.name}
                            </span>
                            <button
                                className="smart-variable-copy-btn"
                                onClick={(e) => onCopyVariable(variable.name, e)}
                                title="Copy to clipboard"
                                type="button"
                            >
                                <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.33333 1.16667H4.66667C3.93029 1.16667 3.33333 1.76362 3.33333 2.5V9.33333H4.66667V2.5H9.33333V1.16667Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M10.5 3.5H6.41667C5.68029 3.5 5.08333 4.09696 5.08333 4.83333V11.6667C5.08333 12.403 5.68029 13 6.41667 13H10.5C11.2364 13 11.8333 12.403 11.8333 11.6667V4.83333C11.8333 4.09696 11.2364 3.5 10.5 3.5ZM10.6667 11.6667H6.25V4.83333H10.6667V11.6667Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        </div>
                        <span className="smart-variable-description">
                            {' - '}
                            {variable.description}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SmartVariablesPanel;

